/** Selector de herrajes desde el Catálogo Soluarq existente (NO crea catálogo nuevo).
 *  Busca por SKU / nombre en backend y filtra por familia / acabado en cliente. */
import { useEffect, useMemo, useState } from 'react';
import api from '@/api/axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

const SEL = 'h-8 text-xs border border-[var(--border)] rounded-md bg-[var(--card)] text-[var(--text)] px-1 w-full';

export const HerrajeCatalogo = ({ open, onClose, onSelect, anclaLabel, sugerencia }) => {
  const [q, setQ] = useState('');
  const [items, setItems] = useState([]);
  const [fam, setFam] = useState('');
  const [acab, setAcab] = useState('');
  useEffect(() => { if (open) { setQ(sugerencia ? sugerencia.replace('°', '') : ''); setFam(''); setAcab(''); } }, [open, sugerencia]);
  useEffect(() => {
    if (!open) return undefined;
    const t = setTimeout(() => {
      api.get('/sa/catalogo', { params: { q } }).then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
    }, 250);
    return () => clearTimeout(t);
  }, [q, open]);
  const familias = useMemo(() => [...new Set(items.map((i) => i.familia).filter(Boolean))], [items]);
  const acabados = useMemo(() => [...new Set(items.map((i) => i.acabado).filter(Boolean))], [items]);
  const list = items.filter((i) => (!fam || i.familia === fam) && (!acab || i.acabado === acab));
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-[560px] max-h-[85vh] overflow-y-auto" aria-describedby={undefined} data-testid="herraje-catalogo-dialog">
        <DialogHeader><DialogTitle className="text-sm">Insertar herraje — Catálogo Soluarq</DialogTitle></DialogHeader>
        <p className="text-[11px] text-[var(--text-muted)]">Ancla: <b className="text-[#0EA5E9]">{anclaLabel || 'punto libre'}</b>{sugerencia ? <> · Sugerido: <b className="text-amber-600">{sugerencia}</b></> : null}</p>
        <div className="grid grid-cols-12 gap-1.5">
          <Input className="h-8 text-xs col-span-6" placeholder="Buscar por SKU o nombre…" value={q}
            onChange={(e) => setQ(e.target.value)} data-testid="hcat-buscar" autoFocus />
          <select className={`${SEL} col-span-3`} value={fam} onChange={(e) => setFam(e.target.value)} data-testid="hcat-familia">
            <option value="">Familia (todas)</option>{familias.map((x) => <option key={x} value={x}>{x}</option>)}
          </select>
          <select className={`${SEL} col-span-3`} value={acab} onChange={(e) => setAcab(e.target.value)} data-testid="hcat-acabado">
            <option value="">Acabado (todos)</option>{acabados.map((x) => <option key={x} value={x}>{x}</option>)}
          </select>
        </div>
        <div className="max-h-[46vh] overflow-y-auto space-y-1" data-testid="hcat-lista">
          {list.length === 0 && <p className="text-[11px] text-[var(--text-muted)] py-3 text-center">Sin resultados en el Catálogo Soluarq.</p>}
          {list.map((it) => (
            <button key={it.codigo} type="button" data-testid={`hcat-item-${it.codigo}`}
              onClick={() => onSelect(it)}
              className="w-full text-left border border-[var(--border)] rounded-md px-2 py-1.5 hover:border-[#0EA5E9] hover:bg-[#0EA5E9]/5 transition-colors">
              <span className="flex items-center justify-between gap-2">
                <span className="text-[11px] font-bold text-[var(--text)] truncate">{it.nombre}</span>
                {Number(it.costo) > 0
                  ? <span className="text-[10px] font-bold text-emerald-600 shrink-0">Q{Number(it.costo).toFixed(2)}</span>
                  : <span className="text-[10px] font-black text-red-500 shrink-0">⚠️ sin costo</span>}
              </span>
              <span className="text-[10px] text-[var(--text-muted)]">{it.codigo}{it.familia ? ` · ${it.familia}` : ''}{it.acabado ? ` · ${it.acabado}` : ''} · {it.unidad || 'unidad'}</span>
            </button>
          ))}
        </div>
        {q.trim().length > 2 && (
          <Button type="button" variant="outline" size="sm" className="h-8 text-[11px] w-full" data-testid="hcat-sin-catalogo"
            onClick={() => onSelect({ codigo: '', nombre: q.trim(), costo: 0, unidad: 'unidad', acabado: '' })}>
            Usar "{q.trim()}" sin catálogo (Q0 — costo pendiente)
          </Button>
        )}
      </DialogContent>
    </Dialog>
  );
};
